import { render } from "./feature-list.vue?vue&type=template&id=51f3b3be&scoped=true"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"

import "./feature-list.vue?vue&type=style&index=0&id=51f3b3be&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f3b3be"]])

export default __exports__